import React from 'react';
import type { Agent } from 'Resources/Agents';

type Props = {
	agent: (Pick<Agent, 'id' | 'name' | 'visibility'> & { avatarUrl?: string | null }) | null;
	size?: 'sm' | 'md';
	onClick?: () => void;
};

const AGENT_PALETTE = [
	'var(--ws-a-prospecting, #5F7F6A)',
	'var(--ws-a-forecasting, #4A6B85)',
	'var(--ws-a-postmeeting, #8B5A8F)',
	'var(--ws-a-alex, #C47A4A)'
];

export const agentColor = (id: number): string => AGENT_PALETTE[id % AGENT_PALETTE.length];

const colorForAgent = (agent: Pick<Agent, 'id' | 'visibility'> | null): string => {
	if (!agent) return 'var(--ws-ink-3, #4b5562)';
	return agentColor(agent.id);
};

const initial = (name: string | undefined): string => {
	if (!name) return '?';
	const c = name.trim().charAt(0);
	return c ? c.toUpperCase() : '?';
};

const AgentChip = ({ agent, size = 'sm', onClick }: Props) => {
	const dim = size === 'md' ? 22 : 16;
	const fontSize = size === 'md' ? 11 : 9;
	const handleClick = onClick
		? (e: React.MouseEvent) => {
				e.stopPropagation();
				onClick();
		  }
		: undefined;

	return (
		<span
			className={`ws-agent-chip ${onClick ? 'ws-agent-chip-clickable' : ''}`}
			onClick={handleClick}
			style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
		>
			{agent?.avatarUrl ? (
				<img
					src={agent.avatarUrl}
					alt=""
					style={{
						width: dim,
						height: dim,
						borderRadius: 4,
						objectFit: 'cover'
					}}
				/>
			) : (
				<span
					className="ws-agent-swatch"
					style={{
						width: dim,
						height: dim,
						borderRadius: 4,
						background: colorForAgent(agent),
						color: 'white',
						fontSize,
						fontWeight: 600,
						display: 'inline-flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					{initial(agent?.name)}
				</span>
			)}
			<span style={{ fontWeight: 600, color: 'var(--ws-ink)' }}>{agent?.name ?? 'Unknown'}</span>
		</span>
	);
};

export default AgentChip;
